import { CURRICULUM } from "@/lib/curriculum";

export default function FolderList({ selected, onSelect, fileCounts = {}, includeIZ }) {
    const visible = CURRICULUM.filter((c) => c.tier === "core" || includeIZ);
    return (
        <div data-testid="workspace-folder-list" className="space-y-1">
            <div className="font-mono-tight text-[10px] uppercase tracking-[0.28em] text-tca-cyan/75 px-2 py-2">
                // A–H {includeIZ && "· I–Z"}
            </div>
            {visible.map((c) => {
                const active = selected === c.letter;
                const n = fileCounts[c.letter] || 0;
                return (
                    <button
                        key={c.letter}
                        type="button"
                        onClick={() => onSelect(c.letter)}
                        data-testid={`folder-${c.letter}`}
                        className={`
                            w-full flex items-center justify-between gap-3 px-3 py-2.5 text-left
                            transition-all duration-200
                            ${active
                                ? "bg-tca-cyan/10 border-l-2 border-tca-cyan text-tca-cyan-hi"
                                : "border-l-2 border-transparent text-tca-ink-muted hover:text-tca-cyan hover:bg-tca-cyan/5"}
                            ${c.tier === "advanced" ? "opacity-70" : ""}
                        `}
                    >
                        <span className="flex items-center gap-2.5 min-w-0">
                            <span className={`font-mono-tight text-sm font-semibold ${active ? "text-tca-cyan-hi" : "text-tca-cyan"}`}>
                                {c.letter}
                            </span>
                            <span className="text-sm truncate">{c.title}</span>
                        </span>
                        {n > 0 && (
                            <span className="font-mono-tight text-[10px] text-tca-ink-muted shrink-0">{n}</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
